export default "__VITE_ASSET__B1A4FcGO__"